/* eslint-disable no-extra-boolean-cast */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { Calendar, Question, CircleTimes } from '../../../../../../components/Icon';
import { ManualDropdown } from '../../../../../../components/ManualDropdown';
import { Loader } from '../../../../../../components/Loader';
import {
  initiateNewVehicleValue,
  setNewVehicleValue,
  deleteVehicleProperty,
  calculatePurchasePriceInclVatExclBPM,
  setNewVehicle,
  retrieveRegplate,
  fetchVehicle,
  searchAutotelex,
  silverdatSearch,
  setNewVehicleOptions,
} from '../../../../actions';
import { selectNewVehicle, selectNewVehicleValue, selectVehicle } from '../../../../selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VehicleCreateFieldBrandName } from '../../FieldBrandName';
import { VehicleCreateFieldModelName } from '../../FieldModelName';
import {
  AUTOTELEX_VEHICLE_PURPOSE,
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  REQUEST_SILVERDAT_GET,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  USER_FILTER_LIST,
  VEHICLE_PURPOSE,
  VEHICLE_TAX_TYPE,
} from '../../../../constants';
import { COMMERCIAL_DEFAULTS_USER_IDS, REQUEST_COMPANIES } from '../../../../../Companies/constants';
import { selectWork, selectWorks } from '../../../../../Api/selectors';
import { selectCompany } from '../../../../../Companies/selectors';
import _ from 'lodash';
import { Well } from '../../../../../../components/Well';
import { OnMouseOverNotification } from '../../../../components/OnMouseOverNotification';
import cn from 'classnames';
import CheckboxComponent from '../../../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../../../containers/App/Components/Button/Button';
import styles from './Fields.module.css';
import { fixPriceFormat } from '../../../../../../utils/string';
import env from '../../../../../../env';
import { AppClientId } from '../../../../../Shared/constants';
import { retrieveVehicleTVI } from '../../../../../ORB/actions';
import { RETRIEVE_VEHICLE_TVI } from '../../../../../ORB/constants';
import { Warning } from '../../../../../../components/Warnings';
import { CompanyUsersSearchSelect } from '../../CompanyUsersSearchSelect';
import { SearchSelect } from '../../../../../../components/SearchSelectComponent';
import { Modal, ModalControls } from '../../../../../../components/Modal';

dayjs.extend(customParseFormat);

const MANUAL_DROPDOWN_OPTIONS = {
  tax_type: ['BTW', 'marge'],
  vehicle_purpose: [
    'passenger',
    'commercial',
    'Trekker/Vrachtwagen',
    'BW >3500kg',
    'Oplegger',
    'Aanhangwagen',
    'Landbouw- of bosbouwtrekker',
    'Motorfiets',
    'Bromfiets',
    'Klein materieel binnenopslag per m2',
    'Klein/middelgroot materieel buitenopslag <6m2',
    'Groot & afwijkend materieel buitenopslag >6m2',
    'chassiscabine_less_3500',
    'chassiscabine_greater_3500',
    'motor',
    'oplegger',
    'aanhanger',
  ],
};

const DROPDOWN_OPTIONS = {
  transport: ['is_available', 'pickup', 'develiver', 'anders'],
  is_owner: ['1', '0'],
};

const Container = styled.div`
  width: 100%;
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }

  .vinTooltip {
    width: 41px;
    //height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();

    if (this.props.type == 'buying_contact') {
      if (COMMERCIAL_DEFAULTS_USER_IDS.includes(+this.props.loggedInUserId)) {
        this.props.setValue(this.props.loggedInUserId, this.props.type);
      }
    }
    if (this.props.type === 'date_expected' && this.props.values?.transport === 'is_available' && !this.props.value) {
      const today = dayjs().format('YYYY-MM-DD HH:mm:ss');
      this.props.setValue(today, 'date_expected');
    }

    if (this.props.type == 'transport') {
      this.props.creditorCompany?.prefence_incoming_transport &&
        this.props.setValue(this.props.creditorCompany?.prefence_incoming_transport, this.props.type);
    }

    if (this.props.type == 'import' && !this.props.values?.import) {
      this.props.setValue('0', this.props.type);
    }
  }

  componentDidUpdate(prevProps) {
    // Check of de prop 'type' overeenkomt
    if (
      this.props.type === 'date_expected' &&
      prevProps.values?.transport !== 'is_available' &&
      this.props.values?.transport === 'is_available' &&
      !this.props.value
    ) {
      const today = dayjs().format('YYYY-MM-DD HH:mm:ss');
      this.props.setValue(today, 'date_expected');
    }
  }

  isDate() {
    return ['date_expected', 'date_first_allowance'].indexOf(this.props.type) > -1;
  }

  isCheckbox() {
    return (
      [
        'new_from_factory',
        'import',
        'task_labels',
        //only hooikammer installation
        //only show following for hooikammer
        'artikelcode',
        'HOOI_uitslag_done',
        'ex_rental',
        'orb_stock_status',
        'HOOI_standard_treatment',
        'HOOI_stalling',
        'HOOI_no_keys',
        'HOOI_task_extreme_cleaning',
        'HOOI_task_desticker',
        'HOOI_task_polish_exterior',
        'HOOI_no_keys',
        'HOOI_rolbaar',
        'HOOI_rijdbaar',
        'HOOI_niet_rolbaar',
        'HOOI_rijdbaar_slechte_accu',
        'make_tasks',
        'SALLAND_poetsen_compleet',
        'SALLAND_poetsen_binnenkant',
        'SALLAND_poetsen_buitenkant',
        'SALLAND_velgen_wisselen',
        'SALLAND_ozon_behandeling',
        'SALLAND_glascoating',
      ].indexOf(this.props.type) > -1
    );
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));

    if (isCheckboxComp) {
      return <div>{children}</div>;
    } else {
      return (
        <div>
          {this.renderFirstDateAllowanceWarningNotification()}
          <label className="form-label">{this.formFieldLabel()}</label>
          {children}
        </div>
      );
    }
  }

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    if (this.props.type === 'vehicle_purpose' && env.clientId === AppClientId.HOOIKAMMER) {
      return this.lbl(`hooikammer.vehicle.property.${this.props.type}`);
    }
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);

    return (
      <div>
        <SearchSelect options={options} value={value} onChange={pair => this.props.setValue(pair.value)} />
      </div>
    );
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'vehicle'}
        key={this.props.type}
        type={this.props.type}
        editable={this.props.type != 'tax_type'}
        deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
        options={vals}
        onChange={this.onChangePurchasePricesData.bind(this)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value =>
          this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
            if (result === true) {
              this.props.setValue('');
            }
          })
        }
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  renderFirstDateAllowanceWarningNotification() {
    if (!this.state.showFirstDateAllowanceWarningNotification) return '';

    return (
      <Modal mediumWide onClose={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
        <strong>{this.lbl('vehicle.property.date_first_allowance_confirmation_msg')}</strong>
        <ModalControls>
          <Button
            style={{ marginRight: '5px' }}
            small
            onClick={() =>
              this.setState({ showFirstDateAllowanceWarningNotification: false }, () => {
                let d = dayjs(this.state.date).format('DD-MM-YYYY');
                this.props.setValue(d);
                this._t = this.timeout(this.calculatePurchasePrice.bind(this), 100, this._t);
              })
            }
          >
            {this.lbl('yes')}
          </Button>
          <Button small onClick={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
            {this.lbl('cancel')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;
    let selected = this.props.value && dayjs(this.props.value, format);
    const isCommercialVehicle = this.props.values.vehicle_purpose === 'commercial';
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected.toDate()}
          onChange={date => {
            let dateFormat = this.props.type === 'date_first_allowance' ? 'DD-MM-YYYY' : 'YYYY-MM-DD hh:mm:ss';
            let d = dayjs(date).format(dateFormat);
            if (
              this.props.type === 'date_first_allowance' &&
              dayjs(date).year() < 2025 &&
              isCommercialVehicle &&
              !this.props.values.incoming_invoice_finalized
            ) {
              this.setState({ showFirstDateAllowanceWarningNotification: true, date });
            } else {
              this.props.setValue(d);
              this._t = this.timeout(this.calculatePurchasePrice.bind(this), 100, this._t);
            }
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  onChangePurchasePricesData(evt) {
    this.props.type == 'financial_purchase_price_excl_vat_excl_bpm' ||
    this.props.type == 'financial_purchase_price_incl_vat_bpm' ||
    this.props.type == 'financial_purchase_price_marge_bpm' ||
    this.props.type == 'financial_purchase_price_marge_excl_bpm' ||
    this.props.type == 'financial_purchase_price_incl_bpm_excl_btw'
      ? this.props.setValue(evt.target.value)
      : this.props.setValue(evt);
    this._t = this.timeout(this.calculatePurchasePrice.bind(this), 1000, this._t);
  }

  calculatePurchasePrice() {
    // if (!this.props.values['financial_purchase_price_excl_vat_excl_bpm']) {
    //   this.props.setValue('', 'financial_purchase_price_incl_vat_excl_bpm');
    // }
    let financeField = '';

    // Check for 2025+ commercial BTW scenario first
    const isCommercial = this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial;
    const isBTW = this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW;
    const dateFirstAllowance = this.props.values?.date_first_allowance;
    const is2025OrLater = dateFirstAllowance ? new Date(dateFirstAllowance).getFullYear() >= 2025 : true;

    if (isCommercial && isBTW && is2025OrLater) {
      financeField = 'financial_purchase_price_incl_bpm_excl_btw';
    } else if (
      (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Commercial) ||
      (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
        this.props.values?.import === '1')
    ) {
      financeField = 'financial_purchase_price_excl_vat_excl_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '0'
    ) {
      financeField = 'financial_purchase_price_incl_vat_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger
    ) {
      financeField = 'financial_purchase_price_marge_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Commercial
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '1'
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    const dto = {
      source: this.props.companySource,
      btwOrMarge: this.props.values?.tax_type,
      vehiclePurpose: this.props.values?.vehicle_purpose,
      isImported: this.props.values?.import === '1',
      buyerType: this.props.companyType || 0,
      rest_bpm: +this.props.values?.rest_bpm ? fixPriceFormat(+this.props.values?.rest_bpm) : fixPriceFormat(0),
      financial_bpm_gross: +this.props.values?.financial_bpm_gross || 0,
      dateFirstAllowance: this.props.values?.date_first_allowance,
    };
    console.log('--------------------------------------------');
    console.log('financeField', financeField);
    console.log('this.props.values[financeField]', this.props.values[financeField]);
    if (financeField) dto[financeField] = +this.props.values[financeField] || 0;
    console.log('dto', dto);
    console.log('--------------------------------------------');


    this.props.calculatePurchasePrices(dto, result => {
      if (Object.keys(result)?.length) {
        Object.keys(result)?.map(price => {
          if ((price === 'outgoing_rest_bpm' || price === 'rest_bpm') && !result[price]) {
            return;
          }
          if (result[price] == 0) {
            if (price === 'rest_bpm') {
              return this.props.setValue(fixPriceFormat(result[price]), price);
            }
            return this.props.setValue('', price);
          }

          return this.props.setValue(result[price], price);
        });
      }
    });
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (this.props.companyWork && this.props.type == 'buying_contact') return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  onRegplateRetrieve = () => {
    const dto = { regplate: this.props.value };
    this.props.searchAutotelex(dto, res => {
      if (!!res) {
        let retrievedVehicle = res?.properties?.reduce((acc, next) => {
          if (
            next?.propertyName == AUTOTELEX_VEHICLE_PURPOSE.PropertyName &&
            next.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Passenger
          ) {
            return { ...acc, [next.propertyName]: next.propertyValue, vehicle_purpose: VEHICLE_PURPOSE.Passenger };
          }

          if (
            next?.propertyName == AUTOTELEX_VEHICLE_PURPOSE.PropertyName &&
            next.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Commercial
          ) {
            return { ...acc, [next.propertyName]: next.propertyValue, vehicle_purpose: VEHICLE_PURPOSE.Commercial };
          }

          if (next?.propertyName === 'vin') {
            const meldcode = next.propertyValue?.slice(-4); // Get last 4 characters of VIN
            return { ...acc, [next.propertyName]: next.propertyValue, meldcode: meldcode };
          }
          return { ...acc, [next.propertyName]: next.propertyValue };
        }, {});
        console.log('RV: ', retrievedVehicle);
        if (retrievedVehicle?.taxiVerleden === '1') {
          retrievedVehicle.rest_bpm = fixPriceFormat(0);
          retrievedVehicle.outgoing_rest_bpm = fixPriceFormat(0);
        }
        this.props.setNewVehicle(retrievedVehicle);
        this.props.setNewVehicleOptions(res.options);
        this.props.setValue(true, 'from_autotelex');

        if (res?.ownerHistory) {
          this.props.setValue(JSON.stringify(res?.ownerHistory), 'ownerHistory');
        }
      }
    });
  };

  retrieveVehicleTVI(regplate, meldcode) {
    this.props.retrieveVehicleTVI(regplate, meldcode, res => {
      if (!res.chassisnummer && !meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeRequired') });
      }
      if (!res.chassisnummer && meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeIncorrect') });
      }

      if (res.chassisnummer) {
        this.props.setValue(`${res.chassisnummer}${meldcode}`, 'vin');
        this.setState({ showGetVinMsg: '' });
      }
    });
  }

  onVinRetrieve = () => {
    const dto = { vin: this.props.value };
    this.props.searchVIN(dto, res => {
      if (res.error) return this.setState({ error: res.error });
      let vehicle = Object.keys(res.Vehicle).map(name => ({ name, value: res.Vehicle[name]?.Value }));
      this.setState({ vinResults: { vehicle } });
    });
  };

  disableCalculatedFields(type) {
    return this.props.workCalc && this.props.type != type;
  }

  renderField() {
    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          className="checkbox"
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            if (this.props.type === 'new_from_factory' && value === '1') {
              const financial_bpm_gross = this.props.values.financial_bpm_gross;
              if (financial_bpm_gross) this.props.setValue(financial_bpm_gross, 'rest_bpm');
            }
            return this.props.setValue(value);
          }}
          label={this.lbl(`vehicle.property.${this.props.type}`)}
        />
      );
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    switch (this.props.type) {
      case 'regplate':
        return (
          <div className={styles.buttonsLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                // disabled={this.props.values?.autotelexKMStand}
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <ButtonComponent
              style="ButtonSoftPrimary"
              disabled={!this.props.values.regplate || this.props.values?.from_autotelex}
              onClick={this.onRegplateRetrieve}
            >
              {this.lbl('vehicle.create.regplate.retrieve')}
            </ButtonComponent>

            {this.props.edit && (
              <ButtonComponent
                style="ButtonSoftDelete"
                disabled={!this.props.vehicle?.regplate}
                onClick={() =>
                  this.props.deleteProperty(this.props.values?.id, 'regplate', result => {
                    if (result === true) {
                      this.props.setValue('');
                    }
                  })
                }
              >
                <CircleTimes />
              </ButtonComponent>
            )}
          </div>
        );
      case 'meldcode':
        return (
          <div>
            <div className={styles.buttonLabel}>
              <div className={styles.labelCompany}>
                <input
                  className="form-control"
                  key={this.props.type}
                  value={this.props.value}
                  onChange={evt => this.props.setValue(evt.target.value)}
                />
              </div>
              {env.clientId === AppClientId.AUTOWIENTJES && (
                <>
                  <ButtonComponent
                    disabled={!this.props.values?.regplate || this.props.workTVI}
                    onClick={() => this.retrieveVehicleTVI(this.props.values?.regplate, this.props.values?.meldcode)}
                  >
                    {this.props.workTVI ? <Loader small /> : this.lbl('vehicle.create.vin.retrieve')}
                  </ButtonComponent>
                  {/* <div className="vinTooltip" title="Enter regplate and meldcode to enable button">
                  <Question/>
                </div> */}
                </>
              )}
            </div>
            {!!this.state.showGetVinMsg && <Warning>{this.state.showGetVinMsg}</Warning>}
          </div>
        );
      case 'vin':
        return (
          <div>
            {this.props.findingVIN ? (
              <Loader small />
            ) : (
              <>
                {this.state.error ? <Well alert>{this.state.error}</Well> : null}
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      key={this.props.type}
                      value={this.props.value}
                      disabled={this.props.workTVI}
                      onChange={evt => this.props.setValue(evt.target.value.toUpperCase())}
                    />
                  </div>
                </div>

                {this.state.vinResults?.vehicle ? (
                  <div>
                    {this.state.vinResults.vehicle.map(result => (
                      <div key={result.name} style={{ marginBottom: '4px' }}>
                        <strong>{result.name}</strong>
                        <br />
                        {result.value}
                      </div>
                    ))}
                  </div>
                ) : null}
              </>
            )}
          </div>
        );
      case 'buying_contact':
        return (
          <CompanyUsersSearchSelect
            key={`${this.props.type}`}
            type={this.props.type}
            userValue={this.props.value}
            onChange={value => this.props.setValue(value)}
          />
        );

      case 'empty_weight':
        return ': ' + this.props.values?.empty_weight;

      case 'body_type':
        return ': ' + this.props.values?.body_type;

      case 'brand_name':
        return (
          <VehicleCreateFieldBrandName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onReset={() => {
              this.props.setValue('');
              this.props.setValue('', 'model_name');
            }}
            onChange={value => this.props.setValue(value)}
            onDeleteValue={value =>
              this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
                if (result === true) {
                  this.props.setValue('');
                  this.props.setValue('', 'model_name');
                }
              })
            }
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );
        break;
      case 'model_name':
        return (
          <VehicleCreateFieldModelName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onChange={value => this.props.setValue(value)}
            onReset={() => this.props.setValue('')}
            onDeleteValue={value => this.props.deleteProperty(this.props.values?.id, this.props.type, result => {})}
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );
      case 'financial_price_b2c':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
          </div>
        );

      case 'extra_cost_transport_kosten_inkomend':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                type="number"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(evt.target.value, 'extra_cost_sum');
                }}
              />
            </div>
          </div>
        );

      case 'financial_purchase_price_incl_vat_excl_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                disabled={true}
                type="number"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
          </div>
        );
      case 'financial_purchase_price_marge_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                disabled={this.disableCalculatedFields('financial_purchase_price_marge_bpm')}
                type="number"
                key={this.props.type}
                value={this.props.value}
                onChange={this.onChangePurchasePricesData.bind(this)}
              />
            </div>
          </div>
        );
      case 'financial_price_b2b_incl_vat_btpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                disabled={this.disableCalculatedFields('financial_purchase_price_marge_bpm')}
                type="number"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
          </div>
        );

      case 'financial_purchase_price_excl_vat_excl_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                disabled={this.disableCalculatedFields('financial_purchase_price_excl_vat_excl_bpm')}
                type="number"
                key={this.props.type}
                value={this.props.value}
                onChange={this.onChangePurchasePricesData.bind(this)}
              />
            </div>
          </div>
        );
      case 'rest_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>

            {this.props.values.taxiVerleden === '1' && (
              <OnMouseOverNotification top="-250px" right="100px" message={this.lbl('alert.is_taxi_tax_message')} />
            )}
          </div>
        );
      case 'financial_bpm_gross':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>

            {this.props.values.taxiVerleden === '1' && (
              <OnMouseOverNotification top="-250px" right="100px" message={this.lbl('alert.is_taxi_tax_message')} />
            )}
          </div>
        );

      case 'mileage':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>KM</div>
          </div>
        );

      case 'model_info':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
          </div>
        );

      case 'financial_purchase_price_incl_vat_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                type="number"
                key={this.props.type}
                value={this.props.value}
                disabled={this.disableCalculatedFields('financial_purchase_price_incl_vat_bpm')}
                onChange={this.onChangePurchasePricesData.bind(this)}
              />
            </div>
          </div>
        );
      case 'financial_purchase_price_marge_excl_bpm':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                type="number"
                key={this.props.type}
                value={this.props.value}
                disabled={this.disableCalculatedFields('financial_purchase_price_marge_excl_bpm')}
                onChange={this.onChangePurchasePricesData.bind(this)}
              />
            </div>
          </div>
        );
      case 'financial_purchase_price_incl_bpm_excl_btw':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.decoratorLabel}>€</div>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                type="number"
                key={this.props.type}
                value={this.props.value}
                disabled={this.disableCalculatedFields('financial_purchase_price_incl_bpm_excl_btw')}
                onChange={this.onChangePurchasePricesData.bind(this)}
              />
            </div>
          </div>
        );
      case 'helga_id':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'articlecode':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
        case 'category_id':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'workflowId':
        const vals = this.props.availableWorkflows ?? [];

        const options = vals.map(val => ({
          value: val.id,
          label: val.name,
        }));

        const value = options.find(o => o.value == this.props.value);

        return (
          <div>
            <SearchSelect
              options={options}
              value={value}
              onChange={pair => {
                this.props.setValue(pair.value);
                this.props.onSelectWorkflow(pair.value);
              }}
            />
          </div>
        );
    }
  }
}

VehicleCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    findingVIN: selectWork(REQUEST_SILVERDAT_GET),
    workTVI: selectWork(RETRIEVE_VEHICLE_TVI),
    workCalc: selectWorks([CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM]),
    companyWork: selectWork(REQUEST_COMPANIES),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
    creditorCompany: selectCompany(ownProps.creditorCompanyId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;

      dispatch(setNewVehicleValue(name, value));
    },
    deleteProperty(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
    calculatePurchasePrices(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
    fetchVehicle(regplate, callback) {
      dispatch(retrieveRegplate(regplate, callback));
    },
    fetchVehicleById(vehicleId, callback) {
      dispatch(fetchVehicle(vehicleId, callback));
    },
    setNewVehicle(data, isAutotelex) {
      dispatch(setNewVehicle(data, isAutotelex));
    },
    setNewVehicleOptions(options) {
      dispatch(setNewVehicleOptions(options));
    },
    searchAutotelex(dto, callback) {
      dispatch(searchAutotelex(dto, callback));
    },
    searchVIN(dto, callback) {
      dispatch(silverdatSearch(dto, callback));
    },
    retrieveVehicleTVI(regplate, meldcode, callback) {
      dispatch(retrieveVehicleTVI(regplate, meldcode, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateField = compose(withConnect, withRouter)(VehicleCreateFieldComp);
